<template>
  <div class="myaccount">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <CommonHead></CommonHead>
    <!-- Create Client Pop Up -->
    <b-modal
      id="create-client"
      ref="crtcltmodal"
      title="Create a New Client"
      title-tag="h3"
      ok-only
      modal-class="common_pop create_client"
    >
      <form
        class="commonform"
        ref="form"
        @submit.stop.prevent="addclientSubmit"
      >
        <b-row>
          <b-col>
            <md-field
              :state="!form.errors.has('name')"
              :class="
                form.errors.get('name')
                  ? 'haserror forstar add-client'
                  : 'forstar add-client'
              "
              :invalid-feedback="form.errors.get('name')"
            >
              <label>Enter a client name</label>
              <md-input
                :state="!form.errors.has('name')"
                @input="form.errors.clear('name')"
                v-model="form.name"
                type="text"
              ></md-input>
              <span class="error-msg" v-if="form.errors.get('name')">{{
                form.errors.get("name") == "The name field is required."
                  ? "Required Field"
                  : form.errors.get("name")
              }}</span>
            </md-field>
            <input type="hidden" v-model="form.user_id" />
          </b-col>
        </b-row>
        <b-button type="submit" block variant="dark">Add</b-button>
        <span class="error-msg" v-if="this.form.error_name != ''"
          >Name already exist!</span
        >
      </form>
    </b-modal>

    <!-- Create Project Pop Up -->
    <b-modal
      id="create-project"
      ref="crtprojmodal"
      title="Create a New Project"
      title-tag="h3"
      ok-only
      modal-class="common_pop create_project"
    >
      <form class="commonform" ref="form" @submit.stop.prevent="AddProject">
        <b-row>
          <b-col>
            <md-field
              :state="!crtprojform.errors.has('name')"
              :class="
                crtprojform.errors.get('name') ? 'haserror forstar' : 'forstar'
              "
              :invalid-feedback="crtprojform.errors.get('name')"
            >
              <label>Enter a project name</label>
              <md-input
                :state="!crtprojform.errors.has('name')"
                @input="crtprojform.errors.clear('name')"
                v-model="crtprojform.name"
                type="text"
              ></md-input>
              <span class="error-msg" v-if="crtprojform.errors.get('name')">{{
                crtprojform.errors.get("name") == "The name field is required."
                  ? "Required Field"
                  : crtprojform.errors.get("name")
              }}</span>
            </md-field>
            <input type="hidden" v-model="crtprojform.client_id" />
          </b-col>
        </b-row>
        <b-button type="submit" block variant="dark">Add</b-button>
        <span class="error-msg" v-if="this.crtprojform.error_name != ''"
          >Name already exist!</span
        >
      </form>
    </b-modal>

    <!-- Edit Client Pop Up -->
    <b-modal
      id="edit-client"
      ref="editmodal"
      title="Edit Client"
      title-tag="h3"
      ok-only
      modal-class="common_pop edit_client"
    >
      <form
        class="commonform"
        ref="form"
        @submit.stop.prevent="editclientSubmit"
      >
        <b-row>
          <b-col>
            <md-field
              :state="!editcltform.errors.has('name')"
              :class="
                editcltform.errors.get('name')
                  ? 'haserror forstar edit-client'
                  : 'forstar edit-client'
              "
              :invalid-feedback="editcltform.errors.get('name')"
            >
              <label>Enter Client Name</label>
              <md-input
                :state="!editcltform.errors.has('name')"
                @input="editcltform.errors.clear('name')"
                v-model="editcltform.name"
                type="text"
              ></md-input>
              <span class="error-msg" v-if="editcltform.errors.get('name')">{{
                editcltform.errors.get("name") == "The name field is required."
                  ? "Required Field"
                  : editcltform.errors.get("name")
              }}</span>
            </md-field>
            <input type="hidden" v-model="editcltform.id" />
          </b-col>
        </b-row>
        <b-button type="submit" block variant="dark">Update</b-button>
        <span class="error-msg" v-if="this.editcltform.error_name != ''"
          >Name already exist!</span
        >
      </form>
    </b-modal>

    <!-- Edit Project Pop Up -->
    <b-modal
      id="edit-project"
      ref="editprojmodal"
      title="Edit Project"
      title-tag="h3"
      ok-only
      modal-class="common_pop edit_project"
    >
      <form
        class="commonform"
        ref="form"
        @submit.stop.prevent="editprojectSubmit"
      >
        <b-row>
          <b-col>
            <md-field
              :state="!editprojform.errors.has('name')"
              :class="
                editprojform.errors.get('name') ? 'haserror forstar' : 'forstar'
              "
              :invalid-feedback="editprojform.errors.get('name')"
            >
              <label>Enter Project Name</label>
              <md-input
                :state="!editprojform.errors.has('name')"
                @input="editprojform.errors.clear('name')"
                v-model="editprojform.name"
                type="text"
              ></md-input>
              <span class="error-msg" v-if="editprojform.errors.get('name')">{{
                editprojform.errors.get("name") == "The name field is required."
                  ? "Required Field"
                  : editprojform.errors.get("name")
              }}</span>
            </md-field>
            <input type="hidden" v-model="editprojform.id" />
          </b-col>
        </b-row>
        <b-button type="submit" block variant="dark">Update</b-button>
        <span
          class="error-msg belowbtn"
          v-if="this.editprojform.error_name != ''"
          >Name already exists!</span
        >
      </form>
    </b-modal>

    <!-- Delete Client Pop Up -->
    <b-modal
      id="delete-client"
      ref="dltcltmodal"
      title="Are you sure you want to delete this client?"
      title-tag="h3"
      ok-only
      modal-class="common_pop delete_client"
    >
      <b-row>
        <b-col cols="7">
          <input type="hidden" v-model="this.cltdeleteid" />
          <b-button @click="deleteClientData" block variant="dark"
            >Delete</b-button
          >
        </b-col>
        <b-col cols="5">
          <b-button @click="hideModal" block variant="outline-primary" squared
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <!-- Confirm Save Project Pop Up -->
    <b-modal
      id="suresave-project"
      ref="savemodal"
      title="Do you want to save the changes?"
      title-tag="h3"
      ok-only
      modal-class="common_pop suresave_project"
    >
      <b-row>
        <b-col cols="7">
          <input type="hidden" v-model="this.saveid" />
          <b-button @click="saveProductData" type="submit" block variant="dark"
            >Yes</b-button
          >
        </b-col>
        <b-col cols="5">
          <b-button @click="hideModal" block variant="outline-primary" squared
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <!-- Save Project Pop Up -->
    <b-modal
      id="save-project"
      ref="successmodal"
      :title="this.successtitle"
      title-tag="h3"
      ok-only
      modal-class="common_pop save_project"
    ></b-modal>

    <!-- Delete Product Pop Up -->
    <b-modal
      id="delete-product"
      ref="dltprodmodal"
      title="Are you sure you want to delete this product?"
      title-tag="h3"
      ok-only
      modal-class="common_pop delete_product"
    >
      <b-row>
        <b-col cols="7">
          <input type="hidden" v-model="this.proddeleteid" />
          <b-button
            @click="deleteProductData"
            type="submit"
            block
            variant="dark"
            >Delete</b-button
          >
        </b-col>
        <b-col cols="5">
          <b-button @click="hideModal()" block variant="outline-primary" squared
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <!-- Delete Project Pop Up -->
    <b-modal
      id="delete-project"
      ref="dltprojmodal"
      title="Are you sure you want to delete this project?"
      title-tag="h3"
      ok-only
      modal-class="common_pop delete_project"
    >
      <b-row>
        <b-col cols="7">
          <input type="hidden" v-model="this.projdeleteid" />
          <b-button
            @click="deleteProjectData"
            type="submit"
            block
            variant="dark"
            >Delete</b-button
          >
        </b-col>
        <b-col cols="5">
          <b-button @click="hideModal" block variant="outline-primary" squared
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <div class="basestyle-backdrop bg-dark" v-if="basestyleshow == true" @click="closeBaseFabrics"></div>
    <div class="basestylecontainer" v-if="basestyleshow == true">
      <div class="row my-5">
        <h3 class="mx-auto pl-65 basecotainertitle">Select a Base</h3>
        <b-img
          class="mr-5 basestylecontainer-close-icon"
          src="/shop/images/close.svg"
          fluid
          alt="close image"
          @click="closeBaseFabrics"
        ></b-img>
      </div>
      <perfect-scrollbar :suppressScrollX="false">
        <SKLoader :repeat="5" :loading="isLoadingBase" speed="1s" class="baseloadercont">
          <SKBaseFabrics/>
        </SKLoader>
        <template v-if="baseFabrics.length > 0 && isLoadingBase == false">
          <template>
            <div v-for="(baseFabric, i) in baseFabrics" class="p-3" :key="i">
              <div class="row mb-5">
                <div class="col-5">
                  <b-img :src="baseFabric.URL" fluid></b-img>
                </div>
                <div class="col-7">
                  <h3 class="text-left mb-3 basefabricname">
                    {{ baseFabric.NAME }}
                  </h3>
                  <p>Price: 
                    <span class="font-weight-normal">
                      $ {{ parseFloat(baseFabric.AMOUNT).toFixed(2) }} / per yd
                    </span>
                  </p>
                  <p class="basefabricdescrip">{{ baseFabric.RMC_BaseFabricDesc }}</p>
                  <hr>
                  <div class="accordion">
                    <a class="text-decoration-none" href="javascript:;" v-b-toggle="'collapse-' + i">
                      Specifications
                    </a>
                    <div class="specification mt-3">
                      <div class="spec_cont">
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Width:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWidth != '' ? parseFloat(baseFabric.RMC_BaseFabricWidth).toFixed(2) : "-" }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Weight:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWeight != '' ? parseFloat(baseFabric.RMC_BaseFabricWeight).toFixed(2) : '' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Content:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricContent != '' ? baseFabric.RMC_BaseFabricContent : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Country:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.LogisticsAddressCountryRegionId != '' ? baseFabric.LogisticsAddressCountryRegionId : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Wyzenbeek:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWyzenbeek != '' ? baseFabric.RMC_BaseFabricWyzenbeek : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Martindale:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricMartindale != '' ? baseFabric.RMC_BaseFabricMartindale : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>CleaningCode:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.CleaningCode != '' ? baseFabric.CleaningCode : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Test Code:</span>
                          </div>
                          <div class="txtspec">
                            <p>
                              {{ baseFabric.rmcFireTestCode1 != '' ? baseFabric.rmcFireTestCode1 : '-' }},
                              {{ baseFabric.rmcFireTestCode2 != '' ? baseFabric.rmcFireTestCode2 : '-' }},
                              {{ baseFabric.rmcFireTestCode3 != '' ? baseFabric.rmcFireTestCode3 : '-' }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <button class="btn btn btn-outline-primary fabricSelectBtn" @click="baseFabricSelected(baseFabric)">SELECT</button>
                </div>
              </div>
              <hr>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-center">
            <h3 class="mt-5">No Fabric Found. </h3>
          </div>
        </template>
      </perfect-scrollbar>
    </div>
    <div class="accountdetails mainprojectsection">
      <sidebar></sidebar>
      <div class="orderspage projectspage">
        <h1 class="account-mobile">Projects</h1>
        <div class="projectlistbar">
          <b-button
            @click="createClient"
            block
            variant="outline-primary"
            squared
          >
            <span>+</span> Add New Client
          </b-button>
          <div class="clientproject">
            <perfect-scrollbar>
              <ul class="mainul">
                <li
                  v-for="(client, index) in this.clientproject"
                  :key="index"
                  :class="index == '0' ? 'active' : ''"
                >
                  <!--<a :ref="'client_'+client.id" :class="client.hasproducts!=''?'hasproducts clientname cid_'+client.id:'clientname cid_'+client.id" :data-name="client.name" :data-id="client.id" href="javascript:;" @click="toggleActiveClass" v-b-toggle="'collapse-' + index">-->
                  <a
                    :ref="'client_' + client.id"
                    :class="'clientname cid_' + client.id + ' index_' + index"
                    :data-name="client.name"
                    :data-id="client.id"
                    href="javascript:;"
                    @click="toggleActiveClass"
                    v-b-toggle="'collapse-' + index"
                  >
                    {{ client.name }}
                    <b-img
                      v-if="client.projects.length > 0"
                      class="arrowrotate"
                      src="/shop/images/arrow.svg"
                      fluid
                      alt="arrow image"
                    ></b-img>
                  </a>
                  <!--<a v-else class="clientname" href="javascript:;">
                    {{client.name}}
                  </a>-->
                  <a
                    @click="deleteClient(client.id)"
                    v-b-tooltip.hover
                    title="Delete Client"
                    class="closeclient"
                    href="javascript:;"
                  >
                    <b-img
                      src="/shop/images/close.svg"
                      fluid
                      alt="Close image"
                    ></b-img>
                  </a>
                  <a
                    @click="editClient(client.id, client.name)"
                    v-b-tooltip.hover
                    title="Edit Client"
                    class="editclient"
                    href="javascript:;"
                  >
                    <b-img
                      src="/shop/images/edit.svg"
                      fluid
                      alt="Edit image"
                    ></b-img>
                  </a>
                  <b-collapse
                    :id="'collapse-' + index"
                    accordion="my-accordion"
                  >
                    <ul class="subul">
                      <li
                        v-if="client.projects.length > 0"
                        v-for="(project, projindex) in client.projects"
                        :key="projindex"
                        :class="
                          'projlist_' + project.id + ' projindex_' + projindex
                        "
                      >
                        <a
                          class="clientname"
                          href="javascript:;"
                          @click="gotoProject(project.id)"
                          >{{ project.name }}</a
                        >
                        <a
                          @click="deleteProject(project.id, client.id)"
                          v-b-tooltip.hover
                          title="Delete Project"
                          class="closeclient"
                          href="javascript:;"
                        >
                          <b-img
                            src="/shop/images/close.svg"
                            fluid
                            alt="Close image"
                          ></b-img>
                        </a>
                        <a
                          @click="
                            editProject(project.id, project.name, client.id)
                          "
                          v-b-tooltip.hover
                          title="Edit Project"
                          class="editclient"
                          href="javascript:;"
                        >
                          <b-img
                            src="/shop/images/edit.svg"
                            fluid
                            alt="Edit image"
                          ></b-img>
                        </a>
                      </li>
                      <li v-else>
                        <a class="clientname" href="javascript:;"
                          >No Project found</a
                        >
                      </li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
            </perfect-scrollbar>
          </div>
        </div>
        <div class="detailedprojects">
          <div class="singleproject">
            <h1>{{ this.loadedclient.name }}</h1>
            <b-button
              @click="createProject"
              v-if="clientproject.length > 0"
              class="float-right"
              variant="outline-primary"
              squared
            >
              <span>+</span> Add New Project
            </b-button>
            <div class="nodata" v-if="clientproject.length <= 0 ">
              There is no client. Please add a new client.
            </div>
            <div class="nodata" v-else-if="clientproject.length > 0 && loadproducts.length <= 0">
              There is no project under the client. Please add a new project.
            </div>
            <div
              :id="'project_' + project.id"
              class="infoDiv"
              v-for="(project, index) in this.loadproducts"
              :key="index"
            >
              <div class="projecttitle">
                <h2>
                  {{ project.name }}
                  <a href="#" v-if="showExport === true">
                    <b-img
                      class="moreopt"
                      src="/shop/images/more-options.svg"
                      fluid
                      alt="more options image"
                    ></b-img>
                    <ul class="moreptions">
                      <li>
                        <a href="javascript:;" @click="GetPDFURL(project.id)"
                          >Email to Client</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:;"
                          @click="GetPDF(project.id, 'export')"
                          >Export PDF</a
                        >
                      </li>
                    </ul>
                  </a>
                </h2>
              </div>
              <div class="createmodifydate">
                <div class="createdate">
                  <span>Created on :</span>
                  <p>{{ project.created_at }}</p>
                </div>
                <div class="modifydate">
                  <span>Last modified on :</span>
                  <p>{{ project.updated_at }}</p>
                </div>
              </div>
              <div class="selectall" v-if="project.products.length > 0">
                <b-row>
                  <b-col>
                    <md-checkbox
                      @change="checkAll(project.id)"
                      v-model="isCheckAll[project.id]"
                      value="1"
                      id="'lorem'+project.id"
                      >Select all</md-checkbox
                    >
                  </b-col>
                  <b-col>
                    <b-button @click="checkoutProduct()" class="float-right" variant="dark" squared>Checkout</b-button>
                    <form ref="formToPrint" action="/shop/printall" method="get" target="_blank">
                      <input type="hidden" name="printitem" v-model="checkboxes">
                      <a @click="printSelectedProducts()" href="#" class="float-right printlarge" title="print Selected">
                        <b-img src="/shop/images/print.svg" fluid alt="print image" ></b-img>
                      </a>
                    </form>
                  </b-col>
                </b-row>
              </div>
              <div v-if="project.products.length > 0">
                <div
                  class="singledetails"
                  v-for="(product, prodindex) in project.products"
                  :key="prodindex"
                >
                  <div class="selectbox">
                    <md-checkbox
                      :class="'pp_' + project.id"
                      v-model="checkboxes"
                      @change="updateCheckall(project.id)"
                      :value="product.id"
                      :id="'lorem' + product.id"
                    ></md-checkbox>
                  </div>
                  <div class="alldetails">
                    <div class="imgbox">
                      <b-img
                        :src="product.productdetail.SMALL_IMAGE"
                        fluid
                        alt="project image"
                      ></b-img>
                    </div>
                    <div class="contentbox">
                      <h3>
                        {{ product.productdetail.ITEMNAME }}
                        {{
                          product.productdetail.COLORNAME
                            ? " / " + product.productdetail.COLORNAME
                            : ""
                        }}
                      </h3>
                      <div class="samediv">
                        <span>ID :</span>
                        <p>
                          {{
                            product.pc_type == "CDI"
                              ? product.productdetail.ITEMID
                              : product.product_id
                          }}
                          {{
                            product.pc_type == "CDI"
                              ? " - " + product.productdetail.INVENTCOLORID
                              : product.inventcolorid
                              ? " - " + product.inventcolorid
                              : ""
                          }}
                        </p>
                      </div>
                      <div class="samediv" v-if="product.productdetail.design_name">
                        <span>Name :</span>
                        <p>{{ product.productdetail.design_name }}</p>
                      </div>
                      <div class="samediv">
                        <span>Order type :</span>
                        <p>{{ product.order_type }}</p>
                      </div>
                      <div class="samediv" v-if="product.productdetail.base_fabric_name">
                        <span>Base Fabric :</span>
                        <p>{{ product.productdetail.base_fabric_name }}</p>
                        <a href="javascript:;" @click="loadBaseFabrics(product.id,product.productdetail.ITEMID,product.productdetail.INVENTCOLORID)" class="editbaseproject">
                          <img src="/shop/images/edit.svg" alt="Edit" />
                        </a>
                      </div>
                      <div class="samediv" v-if="product.productdetail.DISCOUNTPRICE > 0">
                        <span v-if="product.pc_type == 'Fabric' || product.pc_type == 'Trim' || product.pc_type == 'Sample'">Retail Price :</span>
                        <span v-else>Retail Price :</span>
                        <p class="regularprice">
                          $ {{ parseFloat(product.productdetail.Price).toFixed(2) }}
                        </p>
                        <p class="discountamt">
                          $ {{ parseFloat(product.productdetail.DISCOUNTPRICE).toFixed(2) }}
                        </p>
                      </div>
                      <div class="samediv" v-else>
                        <span v-if="product.pc_type == 'Fabric' || product.pc_type == 'Trim' || product.pc_type == 'Sample'">Retail Price :</span>
                        <span v-else>Retail Price :</span>
                        <p>
                          $ {{ parseFloat(product.productdetail.Price).toFixed(2) }}
                        </p>
                      </div>
                      <div class="samediv">
                        <span>Subtotal :</span>
                        <p>$ {{ parseFloat(product.Total).toFixed(2) }}</p>
                      </div>
                      <div class="samediv quantity">
                        <span>Qty :</span>
                        <div class="qtydiv" v-if="product.order_type != 'memo'">
                          <span @click="decrement(product.id)">-</span>
                          <input
                            :id="'qtybox_' + product.id"
                            v-model="product.quantity"
                            readonly
                          />
                          <span @click="increment(product.id)" class="lastspan"
                            >+</span
                          >
                        </div>
                        <p v-else>{{ product.quantity }}</p>
                      </div>
                      <div class="savecancel">
                       <!-- New Print Functional Start-->
                       <a
                          :href="'/shop/print/'+loadedclient.name+'/'+project.name+'/'+product.id+'.pdf'"
                          title="Print"
                          class="saveproj"
                          target="_blank"
                        >
                          <b-img
                            src="/shop/images/print.svg"
                            fluid
                            alt="Edit image"
                          ></b-img>
                        </a>
                         <!-- New Print Functional End -->
                        <a
                          href="javascript:;"
                          @click="(product.pc_type == 'CDI' && product.PROGRAM != 'sheer')? editPromo(product.product_id): () => {}"
                          v-b-tooltip.hover
                          title="Edit Promo Panel"
                          class="saveproj"
                          v-if="product.pc_type == 'CDI' && product.PROGRAM != 'sheer'"
                        >
                          <b-img
                            src="/shop/images/edit.svg"
                            fluid
                            alt="Edit image"
                          ></b-img>
                        </a>
                        <a
                          href="javascript:;"
                          @click="(product.pc_type == 'CDI' && product.PROGRAM == 'sheer') ? editPromoSheer(product.product_id): () => {}"
                          v-b-tooltip.hover
                          title="Edit Promo Panel"
                          class="saveproj"
                          v-if="product.pc_type == 'CDI' && product.PROGRAM == 'sheer'"
                        >
                          <b-img
                            src="/shop/images/edit.svg"
                            fluid
                            alt="Edit image"
                          ></b-img>
                        </a>
                        <a
                          href="javascript:;"
                          @click="product.pc_type == 'CDIQ' ? editQuickShip(product.product_id): () => {}"
                          v-b-tooltip.hover
                          title="Edit Quick Ship"
                          class="saveproj"
                          v-if="product.pc_type == 'CDIQ'"
                        >
                          <b-img
                            src="/shop/images/edit.svg"
                            fluid
                            alt="Edit image"
                          ></b-img>
                        </a>
                        <a
                          href="javascript:;"
                          @click="product.pc_type == 'CDIP' ? editPleated(product.product_id): () => {}"
                          v-b-tooltip.hover
                          title="Edit Pleated Drapery"
                          class="saveproj"
                          v-if="product.pc_type == 'CDIP'"
                        >
                          <b-img
                            src="/shop/images/edit.svg"
                            fluid
                            alt="Edit image"
                          ></b-img>
                        </a>
                        <a
                          :href="product.productdetail.LINKEDIT"
                          v-b-tooltip.hover
                          title="Edit Recolor"
                          class="saveproj"
                          v-if="product.productdetail.COLORWORKS == '1' && product.productdetail.INVENTCOLORID == '99'"
                        >
                          <b-img
                            src="/shop/images/edit.svg"
                            fluid
                            alt="Edit image"
                          ></b-img>
                        </a>
                        <router-link
                          :to="`/shop/custom-print-image-upload/${product.productdetail.custom_print_image_id}`"
                          v-b-tooltip.hover
                          title="Edit Product"
                          class="saveproj"
                          v-if="product.productdetail.ITEMNAME == 'Custom Print' && product.productdetail.ITEMID == 'CW000'"
                        >
                          <b-img
                            src="/shop/images/edit.svg"
                            fluid
                            alt="Edit Project"
                          ></b-img>
                        </router-link>
                        <a
                          href="javascript:;"
                          @click="
                            product.order_type == 'CDI'
                              ? saveConfirmPromo(product.id, product.product_id,product.pc_type)
                              : saveConfirmProduct(product.id)
                          "
                          v-b-tooltip.hover
                          title="Save Product"
                          class="saveproj"
                        >
                          <b-img
                            src="/shop/images/save.svg"
                            fluid
                            alt="Save image"
                          ></b-img>
                        </a>
                        <a
                          href="javascript:;"
                          @click="deleteProduct(product.id)"
                          v-b-tooltip.hover
                          title="Delete Product"
                          class="deleteproj"
                        >
                          <b-img
                            src="/shop/images/close.svg"
                            fluid
                            alt="Close image"
                          ></b-img>
                        </a>
                      </div>
                    </div>
                    <div class="specialint">
                      <input
                        type="text"
                        :id="'notebox_' + product.id"
                        v-model="product.notes"
                        placeholder="Add special instruction"
                        v-show="product.order_type != 'CDI'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="noproducts" v-else>
                There are no products in your project. You may add products to
                the project from
                <router-link to="/shop/products/fabric">here</router-link>.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SKBaseFabrics from "@/views/skeletons/SKBaseFabrics";

export default {
  components: {
    Sidebar,
    CommonHead,
    CommonFoot,
    SKBaseFabrics,
    Loading,
  },
  mixins: [ResourceMixin],
  mounted() {
    this.isLoading = true;
    let mythis = this;
    this.LoadClientAndProject().then(()=>{
      if(this.clientproject.length > 0){
        var querystr = this.$route.query.projectTabId;
        var client_id = Number(querystr);
        if(this.$route.query.projectTabId && !isNaN(client_id)){
          mythis.cid = client_id;
          mythis.cname = $(".mainul .clientname[data-id= '"+mythis.cid+"']").attr("data-name");
        }else{
          mythis.cid = $(".mainul .index_0").attr("data-id");
          mythis.cname = $(".mainul .index_0").attr("data-name");
        }
        for (const li of document.querySelectorAll(".accountdetails .projectspage .projectlistbar .clientproject .mainul li")) {
          li.classList.remove("active");
        }
        //console.log("hh"+this.cid+this.cname);
        mythis.loadSelectedProduct(mythis.cid, mythis.cname, "pageload");

        $(".mainul .cid_" + mythis.cid).parent("li").addClass("active");
        $(".mainul .cid_" + mythis.cid).removeClass("collapsed");
        $(".mainul .cid_" + mythis.cid).addClass("not-collapsed");

        $(".mainul .cid_" + mythis.cid).attr("aria-expanded", true);
        $(".mainul .active .collapse").attr("style", "");
        $(".mainul .active .collapse").addClass("show");

        $(".mainul li .subul li").removeClass("activesubul");
        $(".mainul li.active .subul li.projindex_0").addClass("activesubul");
      }else{
        this.isLoading = false;
      }
    });
  },
  data() {
    return {
      quantity: 1,
      form: new Form({
        name: "",
        user_id: "",
        error_name: "",
      }),
      crtprojform: new Form({
        name: "",
        client_id: "",
        error_name: "",
      }),
      editcltform: new Form({
        id: "",
        name: "",
        user_id: "",
        error_name: "",
      }),
      editprojform: new Form({
        id: "",
        name: "",
        client_id: "",
        error_name: "",
      }),
      form1: new Form({
        email: "",
      }),
      clientproject: [],
      cltdeleteid: "",
      loadedclient: { name: "", id: "" },
      projdeleteid: "",
      proddeleteid: "",
      isLoading: false,
      loadproducts: [],
      saveproduct: "",
      cid: "",
      cname: "",
      saveid: "",
      savePromoId: "",
      saveqty: "",
      savenote: null,
      successtitle: "",
      checkoutproduct: "",
      breadcrumb: [
        {
          text: "My Account",
          active: true,
        },
      ],
      isCheckAll: [],
      checkboxes: [],
      selectedprod: "",
      isPromo: false,
      isPc_type:"",
      showExport: false,
      basestyleshow: false,
      baseFabrics: [],
      baseFabricsRegular: [],
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    checkAll(proj_id) {
      this.checkboxes = [];
      let mythis = this;
      if (this.isCheckAll[proj_id] == "1") {
        // Check all
        this.loadproducts.forEach(function (lp) {
          if (lp.id == proj_id) {
            lp.products.forEach(function (lpsub) {
              mythis.checkboxes.push(lpsub.id);
            });
          }
        });
      }
    },
    updateCheckall: function (proj_id) {
      //console.log(this.checkboxes[proj_id]);
      //console.log("====");
      //console.log(this.checkboxes[proj_id].length);
      // this.loadproducts.forEach(function(lp) {
      //   if(lp.id == proj_id){
      //       console.log(lp.products.length);
      //   }
      // });
      // if(this.checkboxes.length == this.loadproducts.length){
      //    this.isCheckAll = true;
      // }else{
      //    this.isCheckAll = false;
      // }
    },
    checkoutProduct() {
      console.log(this.checkboxes.length,"length");
      if (this.checkboxes.length > 0) {
        this.isLoading = true;
        if (this.checkboxes.length > 15) {
          this.successtitle = "The Shopping Cart is limited to 15 items.";
          this.$refs["successmodal"].show();
          this.isLoading = false;
        }else{
          this.$store.dispatch("checkoutProduct", {
              user_id: this.user.accountnumber,
              product_id: this.checkboxes,
          }).then((response) => {
              if (response.data.success == "limitreached") {
                this.successtitle = "The Shopping Cart is limited to 15 items.";
                this.$refs["successmodal"].show();
              } else if (response.data.success == "ordertypefail") {
                this.successtitle =
                  "You can not add different order type into cart.";
                this.$refs["successmodal"].show();
              } else if (response.data.success == "orderproducttypefail") {
                this.successtitle =
                  "You can not add different product type and order type into cart.";
                this.$refs["successmodal"].show();
              } else if (response.data.success == "exist") {
                this.successtitle =
                  "It looks your cart is already having items. You can either complete that purchase or remove it and purchase the saved project.";
                this.$refs["successmodal"].show();
              } else if (response.data.success == "producttypefail") {
                this.successtitle =
                  "You can not add different product type into cart.";
                this.$refs["successmodal"].show();
              } else {
                this.successtitle = "Product added to cart successfully.";
                this.$refs["successmodal"].show();
                this.$router.push({ name: "checkout" });
              }
              this.isLoading = false;
          });
        }
      } else {
        this.successtitle = "Select one or more products to checkout.";
        this.$refs["successmodal"].show();
        this.isLoading = false;
      }
    },
    printSelectedProducts(){
      console.log(this.checkboxes.length,"length");
      if (this.checkboxes.length > 0) {
        console.log(this.$refs["formToPrint"][0]);
        this.$refs["formToPrint"][0].submit();
      } else {
        this.successtitle = "Select one or more products to print pdf.";
        this.$refs["successmodal"].show();
      }
    },
    createProject() {
      this.crtprojform.name = "";
      this.$refs["crtprojmodal"].show();
    },
    createClient() {
      this.form.name = "";
      this.$refs["crtcltmodal"].show();
    },
    saveConfirmProduct(product_id) {
      this.saveid = product_id;
      this.saveProductData();
      //this.$refs["savemodal"].show();
    },
    saveConfirmPromo(product_id, promo_id, pc_type) {
      this.saveid = product_id;
      this.savePromoId = promo_id;
      this.isPromo = true;
      this.isPc_type = pc_type;
      this.saveProductData();
      //this.$refs["savemodal"].show();
    },
    editPromo(promo_id) {
      this.$router.push(`/shop/promo/update/${promo_id}`);
    },
    editPromoSheer(promo_id) {
      this.$router.push(`/shop/sheer-by-the-inch/update/${promo_id}`);
    },
    editPleated(pleated_id) {
      this.$router.push(`/shop/pleated-drapery/update/${pleated_id}`);
    },
    editQuickShip(quickship_id){
      this.$router.push(`/shop/quick-ship/update/${quickship_id}`);
    },
    saveProductData() {
      this.saveqty = $("#qtybox_" + this.saveid).val();
      this.savenote = $("#notebox_" + this.saveid).val();
      if (this.isPromo) {
        this.savenote = this.isPc_type;
      } else if (this.savenote) {
        //this.savenote=this.savenote;
      } else {
        this.savenote = null;
      }
      let mythis = this;
      this.$store
        .dispatch("saveProduct", {
          product_id: this.isPromo ? this.savePromoId : this.saveid,
          notes: this.savenote,
          qty: this.saveqty,
        })
        .then((saveproduct) => {
          this.isPromo = false;
          this.isPc_type = "";
          //this.saveproduct = saveproduct.data;
          mythis.successtitle = "Product updated successfully.";
          mythis.$refs["savemodal"].hide();
          mythis.$refs["successmodal"].show();

          if (mythis.savenote == null) {
            $("#notebox_" + mythis.saveid).val("");
          }

          $("#qtybox_" + mythis.saveid).val(mythis.saveqty);
        })
        .catch(() => {
          this.isPromo = false;
          this.isPc_type = "";
        });
    },
    loadSelectedProduct(client_id, name, byclk = "") {
      this.isLoading = true;
      if (byclk == "") {
        $(".mainul .clientname").removeClass("collapsed");
        $(".mainul .clientname").addClass("not-collapsed");
        $(".mainul .clientname").attr("aria-expanded", true);
        $(".mainul li .collapse").css("display", "none");
        $(".mainul li .collapse").removeClass("show");

        $(".mainul .cid_" + client_id).attr("aria-expanded", true);
        $(".mainul .active .collapse").attr("style", "");
        $(".mainul .active .collapse").addClass("show");
      }

      this.checkboxes = [];
      this.loadedclient.name = name;
      this.loadedclient.id = client_id;
      this.crtprojform.client_id = client_id;
      if (client_id > 0) {
        this.$store
          .dispatch("LoadProjectProduct", client_id)
          .then((loadproducts) => {
            this.loadproducts = loadproducts.data;
            this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      }
    },
    gotoProject(id) {
      $(".mainul .subul li").removeClass("activesubul");
      $(".projlist_" + id).addClass("activesubul");
      $("html,body").animate(
        {
          scrollTop: $("#project_" + id).offset().top - 115,
        },
        1000
      );
    },
    editClient(id, name) {
      this.editcltform.name = name;
      this.editcltform.id = id;
      this.editcltform.user_id = this.user.accountnumber;
      this.$refs["editmodal"].show();
    },
    deleteClient(id) {
      this.cltdeleteid = id;
      this.$refs["dltcltmodal"].show();
    },
    editProject(id, name, cid) {
      this.editprojform.name = name;
      this.editprojform.id = id;
      this.editprojform.client_id = cid;
      this.$refs["editprojmodal"].show();
    },
    deleteProject(id, cid) {
      this.projdeleteid = id;
      this.cltdeleteid = cid;
      this.$refs["dltprojmodal"].show();
    },
    deleteProduct(id) {
      this.proddeleteid = id;
      this.$refs["dltprodmodal"].show();
    },
    increment(id) {
      var val = parseInt(document.getElementById("qtybox_" + id).value);
      val = val + 1;
      document.getElementById("qtybox_" + id).value = val;
      //this.updateQty(val,id);
      //console.log(this.loadproducts);
      this.loadproducts.forEach((p, o) => {
        p.products.map((d, i) => {
          if (d.id == id) {
            this.loadproducts[o].products[i].quantity = val;
            this.loadproducts[o].products[i].Total = val * this.loadproducts[o].products[i].productdetail.Price;
            if(d.order_type == 'CDI'){
              this.saveConfirmPromo(d.id,d.product_id,d.pc_type);
            }else{
              this.saveConfirmProduct(d.id);
            }
          }
          // console.log(d);
        });
      });
    },
    decrement(id) {
      var val = parseInt(document.getElementById("qtybox_" + id).value);
      if (val === 1) {
        console.log("Negative quantity not allowed");
      } else {
        val = val - 1;
        document.getElementById("qtybox_" + id).value = val;
        //this.updateQty(val,id);
      }
      this.loadproducts.forEach((p, o) => {
        p.products.map((d, i) => {
          if (d.id == id) {
            this.loadproducts[o].products[i].quantity = val;
            this.loadproducts[o].products[i].Total = val * this.loadproducts[o].products[i].productdetail.Price;
            if(d.order_type == 'CDI'){
              this.saveConfirmPromo(d.id,d.product_id,d.pc_type);
            }else{
              this.saveConfirmProduct(d.id);
            }
          }
          // console.log(d);
        });
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    AddProject(evt) {
      evt.preventDefault();

      this.isLoading = true;
      this.$store
        .dispatch("AddProject", {
          form: this.crtprojform,
        })
        .then((response) => {
          if (response.data.success) {
            this.LoadClientAndProject();
            this.loadSelectedProduct(
              this.crtprojform.client_id,
              $("mainul .cid_" + this.crtprojform.client_id).attr("data-name")
            );
            this.$refs["crtprojmodal"].hide();
            this.$notify({
              text: "Project added successfully",
              type: "success",
            });
            this.crtprojform = new Form({
              client_id: this.crtprojform.client_id,
              name: null,
              error_name: "",
            });
          } else {
            this.$notify({
              text: "please try again!",
              type: "error",
            });
            this.crtprojform.error_name = response.data.error;
            this.isLoading = false;
          }
        });
    },
    hideModal() {
      //this.$refs["modal"].hide();
      this.$refs["editmodal"].hide();
      this.$refs["editprojmodal"].hide();
      this.$refs["dltprojmodal"].hide();
      this.$refs["dltcltmodal"].hide();
      this.$refs["crtprojmodal"].hide();
      this.$refs["crtcltmodal"].hide();
      this.$refs["dltprodmodal"].hide();
      this.$refs["savemodal"].hide();
      this.$refs["successmodal"].hide();
    },
    toggleActiveClass(event) {
      event.preventDefault();
      for (const li of document.querySelectorAll(
        ".accountdetails .projectspage .projectlistbar .clientproject .mainul li"
      )) {
        li.classList.remove("active");
      }
      if (event.target.classList.contains("collapsed")) {
        event.target.parentElement.classList.add("active");

        this.loadSelectedProduct(
          event.target.getAttribute("data-id"),
          event.target.getAttribute("data-name")
        );
      } else {
        event.target.parentElement.classList.remove("active");
      }

      $(".mainul li .subul li").removeClass("activesubul");
      $(".mainul li.active .subul li.projindex_0").addClass("activesubul");
    },
    addclientSubmit(evt) {
      evt.preventDefault();

      this.form.user_id = this.user.accountnumber;
      this.form.error_name = "";

      this.isLoading = true;
      this.$store
        .dispatch("AddClient", {
          form: this.form,
        })
        .then((response) => {
          if (response.data.success) {
            this.form.error_name = "";
            this.LoadClientAndProject();
            this.$notify({
              text: "Client added successfully",
              type: "success",
            });
            this.crtprojform.client_id = response.data.success.id;
            this.form = new Form({
              name: null,
              user_id: "",
              error: "",
              error_name: "",
            });
            this.$refs["crtcltmodal"].hide();
            this.isLoading = false;
          } else {
            this.$notify({
              text: "please try again!",
              type: "error",
            });

            this.form.error_name = response.data.error;
            this.isLoading = false;
          }
        });
    },
    editclientSubmit(evt) {
      evt.preventDefault();
      this.editcltform.user_id = this.user.accountnumber;
      this.isLoading = true;
      this.$store
        .dispatch("EditClient", {
          form: this.editcltform,
        })
        .then((response) => {
          if (response.data.success) {
            this.editcltform.error_name = "";
            this.LoadClientAndProject();

            this.$notify({
              text: "Client updated successfully",
              type: "success",
            });
            if (
              $(".mainul .cid_" + this.editcltform.id)
                .parent("li")
                .hasClass("active")
            ) {
              this.loadedclient.name = this.editcltform.name;
            }
            this.editcltform = new Form({
              name: null,
              id: "",
              error_name: "",
              user_id: "",
            });
            $(".edit-client").removeClass("haserror");
            this.$refs["editmodal"].hide();
            /* this.successtitle="Client updated successfully";
		   this.$refs["successmodal"].show();*/
          } else {
            this.$notify({
              text: "please try again!",
              type: "error",
            });

            this.editcltform.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    deleteClientData() {
      this.isLoading = true;
      let mythis = this;
      if (this.cltdeleteid != "") {
        this.$store.dispatch("DeleteClient", this.cltdeleteid).then((response) => {
            if (response.data.success) {
              this.LoadClientAndProject().then(()=>{
                this.$notify({
                  text: "Client deleted successfully",
                  type: "success",
                });
                this.$refs["dltcltmodal"].hide();
                mythis.cid = $(".mainul .index_0").attr("data-id");
                mythis.cname = $(".mainul .index_0").attr("data-name");
                //console.log("hh"+this.cid+this.cname);
                mythis.loadSelectedProduct(mythis.cid,mythis.cname,"pageload");

                $(".mainul .cid_" + mythis.cid).parent("li").addClass("active");
                $(".mainul .cid_" + mythis.cid).removeClass("collapsed");
                $(".mainul .cid_" + mythis.cid).addClass("not-collapsed");

                $(".mainul .cid_" + mythis.cid).attr("aria-expanded", true);
                $(".mainul .active .collapse").attr("style", "");
                $(".mainul .active .collapse").addClass("show");

                $(".mainul li .subul li").removeClass("activesubul");
                $(".mainul li.active .subul li.projindex_0").addClass("activesubul");
                this.isLoading = false;
              });
            } else {
              this.isLoading = false;
              this.$notify({
                text: "please try again!",
                type: "error",
              });
            }
          });
      } else {
        this.isLoading = false;
        this.$notify({
          text: "something went wrong. please try again!",
          type: "error",
        });
      }
    },
    editprojectSubmit(evt) {
      evt.preventDefault();

      this.isLoading = true;
      this.$store
        .dispatch("EditProject", {
          form: this.editprojform,
        })
        .then((response) => {
          if (response.data.success) {
            this.LoadClientAndProject();
            this.loadSelectedProduct(
              this.editprojform.client_id,
              $("mainul .cid_" + this.editprojform.client_id).attr("data-name")
            );
            this.$notify({
              text: "Project updated successfully",
              type: "success",
            });

            this.editcltform = new Form({
              name: null,
              id: "",
              error_name: "",
            });
            this.$refs["editprojmodal"].hide();
            /*this.successtitle="Project updated successfully";
			this.$refs["successmodal"].show();*/
          } else {
            this.$notify({
              text: "please try again!",
              type: "error",
            });

            this.editprojform.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    deleteProjectData() {
      this.isLoading = true;
      if (this.projdeleteid != "") {
        this.$store
          .dispatch("DeleteProject", this.projdeleteid)
          .then((response) => {
            if (response.data.success) {
              this.LoadClientAndProject();
              this.loadSelectedProduct(
                this.cltdeleteid,
                $("mainul .cid_" + this.cltdeleteid).attr("data-name")
              );
              this.$notify({
                text: "Client deleted successfully",
                type: "success",
              });
              this.$refs["dltprojmodal"].hide();

              this.cltdeleteid = "";
              /*this.successtitle="Client deleted successfully";
				this.$refs["successmodal"].show();*/
            } else {
              this.$notify({
                text: "please try again!",
                type: "error",
              });
            }
          });
      } else {
        this.$notify({
          text: "something went wrong. please try again!",
          type: "error",
        });
      }
      this.isLoading = false;
    },
    deleteProductData() {
      this.isLoading = true;
      if (this.proddeleteid != "") {
        this.$store
          .dispatch("DeleteProduct", this.proddeleteid)
          .then((response) => {
            if (response.data.success) {
              if (this.loadedclient.id) {
                this.$store
                  .dispatch("LoadProjectProduct", this.loadedclient.id)
                  .then((loadproducts) => {
                    this.loadproducts = loadproducts.data;
                  });
              }
              this.$notify({
                text: "Product deleted successfully",
                type: "success",
              });
              this.$refs["dltprodmodal"].hide();
              /* this.successtitle="Product deleted successfully";
			this.$refs["successmodal"].show();*/
            } else {
              this.$notify({
                text: "please try again!",
                type: "error",
              });
            }
          });
      } else {
        this.$notify({
          text: "something went wrong. please try again!",
          type: "error",
        });
      }
      this.isLoading = false;
    },
    resetModal() {
      this.name = "";
      this.nameState = null;
    },
    LoadClientAndProject() {
      return this.$store.dispatch("LoadClientAndProject", this.user.accountnumber).then((loadclientsproj) => {
          this.clientproject = loadclientsproj.data;
      });
    },
    GetPDF(project_id, type) {
      this.$store
        .dispatch("loadProjectPDF", {
          project_id: project_id,
          customer_id: this.user.accountnumber,
        })
        .then((response) => {
          if (type == "export") {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "product.pdf");
            document.body.appendChild(link);
            link.click();
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href =
              'mailto:?subject=RECOMMENDATIONS FOR YOU&body= Click on link to view PDF <a href="' +
              url +
              '" download="project.pdf">';
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
          }
        });
    },
    GetPDFURL(project_id) {
      this.$store
        .dispatch("loadProjectPDFURL", {
          project_id: project_id,
          customer_id: this.user.accountnumber,
        })
        .then((response) => {
          if (response.data.status) {
            const link = document.createElement("a");
            link.href = `mailto:?subject=${encodeURI(
              "RECOMMENDATIONS FOR YOU"
            )}&body=${encodeURI(
              `Click on link to view PDF ${
                location.origin + "/" + response.data.path
              }`
            )}`;
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
          } else {
            this.$notify({
              text: response.data.msg || "Failed to Generate PDF",
              type: "error",
            });
          }
          console.log(response, "response");
        });
    },
    loadBaseFabrics(product_id,itemid,inventcolorid){
      this.isLoadingBase = true;
      this.basestyleshow = true;
      this.$store.dispatch('getProductBaseFabrics', {
        itemId: itemid,
        inventColorId: inventcolorid,
      }).then(baseFabrics => {
        this.baseFabricsRegular = baseFabrics.data;
        this.baseFabrics = this.baseFabricsRegular;
        this.isLoadingBase = false;
        this.saveid = product_id;
      });
    },
    closeBaseFabrics() {
      this.basestyleshow = false;
    },
    baseFabricSelected(fabric) {
      this.basestyleshow = false;
      let mythis = this;
      this.isLoading = true;
      this.$store.dispatch("saveProductBaseFabric", {
        product_id: this.saveid,
        basefabric: fabric.NAME,
        basestyle: fabric.INVENTSTYLEID,
      }).then((saveproduct) => {
        this.$store
          .dispatch("LoadProjectProduct", this.loadedclient.id)
          .then((loadproducts) => {
            this.loadproducts = loadproducts.data;
            mythis.successtitle = "Product updated successfully.";
            mythis.$refs["successmodal"].show();
            this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      });
    },
  },
};
</script>
<style>
.b-tooltip .tooltip-inner {
    max-width: 200px;
    padding: 0.25rem 0.5rem;
    color: #fff;
    text-align: center;
    background-color: #303030;
    border-radius: 3px;
}

.nodata {
    width: 100%;
    position: relative;
    overflow: hidden;
}

.mainprojectsection .sidebar {
    box-shadow: 0 10px 12px rgb(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 10px 12px rgb(0, 0, 0, 0.2);
    -moz-box-shadow: 0 10px 12px rgb(0, 0, 0, 0.2);
}

.headwrap.positionfix+.accountdetails .sidebar,
.headwrap.positionfix+.accountdetails.mainprojectsection .orderspage.projectspage .projectlistbar {
    top: 90px;
}

.headwrap.positionfix+.accountdetails .projectspage .detailedprojects {
    margin-top: 115px;
}

.accountdetails .projectspage {
    margin: 0 0 0 26.3%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: stretch;
}

.accountdetails .projectspage .projectlistbar {
    background: #d2d2d2;
    padding: 40px 0;
    max-width: 320px;
    width: 100%;
    position: fixed;
    height: 100%;
    top: 125px;
}

.accountdetails .projectspage .projectlistbar .btn.btn-outline-primary {
    max-width: 212px;
    margin: 0 auto 35px auto;
    display: block;
}

.accountdetails .projectspage .projectlistbar .btn.btn-outline-primary span {
    float: none;
    color: #303030;
    font-size: 18px;
    position: relative;
    top: 3px;
}

.accountdetails .projectspage .projectlistbar .btn.btn-outline-primary:hover span {
    color: #fff;
}

.accountdetails .projectspage .projectlistbar .clientproject .ps {
    height: 500px;
    margin-bottom: 50px;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li {
    width: 100%;
    padding: 24px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #fff;
    position: relative;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a {
    font-weight: normal;
    color: #303030;
    font-size: 16px;
    text-decoration: none;
    position: relative;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a.clientname {
    padding: 24px 0px 24px 35px;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a.clientname:hover {
    text-shadow: 0px 0px 1px #303030;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a img.arrowrotate {
    transform: rotate(-90deg);
    margin-left: 20px;
    position: relative;
    z-index: -1;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a.editclient {
    margin-right: 20px;
    float: right;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a.editclient:hover,
.accountdetails .projectspage .projectlistbar .clientproject .mainul li a.closeclient:hover {
    opacity: 0.8;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a.closeclient {
    float: right;
    margin-right: 35px;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a.editclient img {
    height: 15px;
    width: 15px;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li a img {
    height: 12px;
    width: 12px;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li .subul {
    position: relative;
    width: 100%;
    background: #ececec;
    margin-top: 24px;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li .subul li {
    padding: 24px 0;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li .subul li.activesubul {
    background: #fff;
    border-bottom: 0;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li .subul li {
    border-bottom: 1px solid #303030;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li .subul li a {
    font-size: 14px;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li .subul li.activesubul a {
    font-weight: 500;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li .subul li:last-child {
    border-bottom: 0;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li.active {
    padding-bottom: 0;
}

.accountdetails .projectspage .projectlistbar .clientproject .mainul li.active a .arrowrotate {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}

.accountdetails .projectspage .detailedprojects {
    margin: 0 0 0 320px;
    padding: 40px 0 0 40px;
    box-sizing: border-box;
    width: 100%;
    min-height: 700px;
}

.accountdetails .projectspage .detailedprojects .singleproject {
    max-width: 790px;
    width: 100%;
    margin: 0;
    padding: 0;
}

.accountdetails .projectspage .detailedprojects .singleproject .noproducts {
    margin-bottom: 70px;
}

.accountdetails .projectspage .detailedprojects .singleproject h1 {
    float: left;
    text-align: left;
}

.accountdetails .projectspage .detailedprojects .singleproject .float-right {
    width: 220px;
}
.accountdetails .projectspage .detailedprojects .singleproject .printlarge {
    width: 25px;
    margin-right: 20px;
    line-height: 45px;
}

.accountdetails .projectspage .detailedprojects .singleproject .float-right span {
    float: none;
    color: #303030;
    font-size: 18px;
    position: relative;
    top: 3px;
}

.accountdetails .projectspage .detailedprojects .singleproject .btn:hover span {
    color: #fff;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle {
    width: 100%;
    position: relative;
    display: inline-block;
    margin-top: 25px;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 {
    text-align: left;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 a {
    position: relative;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 img.moreopt {
    height: 5px;
    width: 20px;
    margin-left: 20px;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 a ul {
    position: absolute;
    top: 22px;
    left: 15px;
    border: 1px solid #d2d2d2;
    background: #fff;
    padding: 20px 20px 10px 20px;
    box-sizing: border-box;
    min-width: 160px;
    display: none;
    z-index: 1;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 a:hover ul {
    display: block;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 a ul li a {
    font-size: 14px;
    line-height: 28px;
    color: #303030;
    font-weight: normal;
    text-decoration: none;
    margin-bottom: 10px;
    display: inline-block;
}

.accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 a ul li a:hover {
    font-weight: 600;
}

.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate {
    position: relative;
    width: 100%;
    display: inline-block;
    margin: 20px 0 0 0;
}

.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .createdate,
.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .modifydate {
    float: left;
}

.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .createdate {
    margin-right: 20px;
}

.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .createdate span,
.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .modifydate span,
.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .createdate p,
.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .modifydate p {
    float: left;
    font-size: 12px;
    color: #777777;
    margin-right: 5px;
}

.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .createdate p,
.accountdetails .projectspage .detailedprojects .singleproject .createmodifydate .modifydate p {
    color: #303030;
    margin: 0;
    line-height: 24px;
}

.accountdetails .projectspage .detailedprojects .singleproject .selectall {
    margin: 20px 0 0 0;
    display: inline-block;
    width: 100%;
}

.accountdetails .projectspage .detailedprojects .singleproject .selectall .btn-dark {
    max-width: 155px;
    margin: 0;
}

.accountdetails .projectspage .detailedprojects .singleproject .selectall label {
    font-size: 14px;
    color: #777777;
    font-weight: normal;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails {
    width: 100%;
    position: relative;
    overflow: hidden;
    margin: 25px 0 0 0;
    padding-bottom: 30px;
    border-bottom: 1px solid #d2d2d2;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails:last-child {
    border-bottom: 0;
    margin-bottom: 70px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .selectbox {
    float: left;
    width: 5%;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails {
    width: 95%;
    float: right;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox {
    position: relative;
    width: 67.6%;
    float: left;
    margin-left: 15px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .imgbox {
    width: 27.4%;
    float: left;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .imgbox img {
    width: 100%;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox h3 {
    text-align: left;
    width: 80%;
    line-height: 22px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv {
    line-height: 25px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv span {
    margin-right: 5px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv p {
    color: #303030;
    line-height: 24px;
    font-size: 14px;
    float: left;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv p.regularprice {
    float: left;
    text-decoration: line-through;
    margin-right: 10px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv p.discountamt {
    float: left;
    width: auto;
    color: red;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv.quantity span,
.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv.quantity p {
    margin-top: 5px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv .qtydiv span {
    float: left;
    font-size: 18px;
    border: 1px solid #d2d2d2;
    margin: 0;
    height: 35px;
    line-height: 35px;
    padding: 0 8px;
    font-weight: 500;
    color: #303030;
    -webkit-border-top-left-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    -moz-border-radius-bottomleft: 3px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    cursor: pointer;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv .qtydiv span.lastspan {
    -webkit-border-top-right-radius: 3px;
    -webkit-border-bottom-right-radius: 3px;
    -moz-border-radius-topright: 3px;
    -moz-border-radius-bottomright: 3px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    -webkit-border-top-left-radius: 0;
    -webkit-border-bottom-left-radius: 0;
    -moz-border-radius-topleft: 0;
    -moz-border-radius-bottomleft: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    line-height: 39px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv .qtydiv input {
    float: left;
    max-width: 45px;
    font-size: 14px;
    height: 35px;
    text-align: center;
    border-top: 1px solid #d2d2d2;
    border-bottom: 1px solid #d2d2d2;
    border-left: 0;
    border-right: 0;
    font-weight: 500;
    color: #303030;
    padding-top: 6px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv a.editbaseproject {
    line-height: 24px;
    float: left;
    padding-left: 25px;
}
.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .samediv a.editbaseproject img {
    width: 15px;
    height: 15px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .savecancel {
    position: absolute;
    top: 0;
    right: 0;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .savecancel a {
    display: inline-block;
    margin-left: 25px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .savecancel a:hover {
    opacity: 0.8;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .savecancel img {
    height: 15px;
    width: 15px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox .savecancel .deleteproj img {
    height: 13px;
    width: 13px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .specialint {
    width: 100%;
    float: right;
    margin-top: 10px;
}

.accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .specialint input {
    width: 100%;
    font-size: 14px;
    color: #777777;
    padding: 6.5px 10px;
    box-sizing: border-box;
    border-radius: 3px;
    box-shadow: none;
    background: #fff;
    border: 1px solid #d2d2d2;
}

.common_pop.save_project h3 {
    margin-top: 15px;
}

.common_pop.save_project .modal-body,
.common_pop.save_project .modal-footer {
    display: none;
}

.common_pop.delete_client .modal-dialog.modal-md,
.common_pop.delete_product .modal-dialog.modal-md,
.common_pop.delete_project .modal-dialog.modal-md {
    max-width: 490px;
}

.common_pop.delete_client .modal-dialog.modal-md h3,
.common_pop.delete_product .modal-dialog.modal-md h3,
.common_pop.delete_project .modal-dialog.modal-md h3 {
    margin-top: 20px;
}

@media only screen and (min-width: 1441px) and (max-width: 1680px) {
    .accountdetails .projectspage .projectlistbar {
        max-width: 280px;
    }
    .accountdetails .projectspage .detailedprojects {
        margin-left: 280px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject {
        max-width: 770px;
    }
    .accountdetails .projectspage .projectlistbar .clientproject .mainul li a.closeclient {
        margin-right: 25px;
    }
    .accountdetails .projectspage .projectlistbar .clientproject .mainul li a.clientname {
        padding-left: 25px;
    }
}

@media only screen and (max-width: 1440px) {
    .accountdetails .orderspage {
        margin-left: 400px;
    }
    .accountdetails .projectspage .detailedprojects {
        padding: 40px 20px 0 20px;
    }
}

@media only screen and (max-width: 1360px) {
    .accountdetails .orderspage {
        margin-left: 350px;
    }
}

@media only screen and (max-width: 1199px) and (min-width: 1025px) {
    .accountdetails .projectspage .projectlistbar {
        max-width: 300px;
    }
    .accountdetails .projectspage .detailedprojects {
        margin-left: 290px;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .headwrap.positionfix+.accountdetails .sidebar,
    .headwrap.positionfix+.accountdetails.mainprojectsection .orderspage.projectspage .projectlistbar {
        top: 70px;
    }
    .accountdetails.mainprojectsection .sidebar {
        display: none;
    }
    .accountdetails .orderspage.projectspage {
        margin-left: 0 !important;
    }
    .accountdetails .projectspage .projectlistbar {
        top: 105px;
    }
    .accountdetails .projectspage .projectlistbar {
        max-width: 260px;
    }
    .accountdetails .projectspage .detailedprojects {
        margin-left: 260px;
    }
    .accountdetails .projectspage .projectlistbar .clientproject .mainul li a.closeclient {
        margin-right: 15px;
    }
    .accountdetails .projectspage .projectlistbar .clientproject .mainul li a.editclient {
        margin-left: 10px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .float-right {
        width: 180px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .selectall .btn-dark {
        max-width: 125px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails {
        width: 93%;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .singledetails:last-child {
        margin-bottom: 10px;
    }
    .accountdetails .projectspage .projectlistbar .clientproject .mainul li a.clientname {
        padding-left: 15px;
    }
}

@media only screen and (max-width: 767px) {
    .headwrap.positionfix+.accountdetails .sidebar,
    .headwrap.positionfix+.accountdetails.mainprojectsection .orderspage.projectspage .projectlistbar {
        top: auto;
    }
    .common_pop .modal-dialog.modal-md .modal-content {
        padding: 20px 20px 40px 20px;
        box-sizing: border-box;
    }
    .orderspage.projectspage .account-mobile {
        padding: 0 20px;
        margin-top: 40px;
    }
    .mainprojectsection .sidebar h1 {
        font-size: 24px !important;
    }
    .mainprojectsection .sidebar {
        padding-top: 18px;
        padding-bottom: 8px;
    }
    .mainprojectsection .sidebar ul.nav.accountnav.flex-column {
        display: none;
    }
    .accountdetails.mainprojectsection .projectspage .projectlistbar {
        max-width: 100%;
        width: 100%;
        position: relative;
        height: auto;
        top: auto;
        max-height: 325px;
        border-bottom: 1px solid #303030;
        padding: 30px 0 0 0;
    }
    .accountdetails.mainprojectsection .orderspage {
        margin: 0;
        flex-wrap: wrap;
        align-items: initial;
        max-width: 100% !important;
    }
    .accountdetails.mainprojectsection .projectspage .detailedprojects {
        padding: 40px 20px 0 20px;
        margin: 0;
    }
    .accountdetails.mainprojectsection .projectspage .projectlistbar .clientproject .ps {
        height: 230px;
    }
    .headwrap.positionfix+.accountdetails .projectspage .detailedprojects {
        margin-top: 0px;
        margin-bottom: 30px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject h1 {
        font-size: 24px !important;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .projecttitle h2 {
        font-size: 18px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .float-right {
        width: 180px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .selectall .btn-dark {
        max-width: 120px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .contentbox {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .singledetails .alldetails .imgbox {
        width: 100%;
        float: none;
        max-width: 240px;
        margin: 0 auto;
    }
    .accountdetails .projectspage .detailedprojects .singleproject .singledetails:last-child {
        margin-bottom: 20px;
    }
    .accountdetails .projectspage .projectlistbar .btn.btn-outline-primary {
        margin: 0 auto 15px auto;
    }
}
</style>